import React, { useState, useEffect } from "react";
import classes from "./Timer.module.css";

const Timer = (props) => {
    const [second, setSecond] = useState("00");
    const [minute, setMinute] = useState("00");
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        let intervalId;

        if (props.start) {
            intervalId = setInterval(() => {
                const secondCounter = counter % 60;
                const minuteCounter = Math.floor(counter / 60);

                let computedSecond =
                    String(secondCounter).length === 1
                        ? `0${secondCounter}`
                        : secondCounter;
                let computedMinute =
                    String(minuteCounter).length === 1
                        ? `0${minuteCounter}`
                        : minuteCounter;

                setSecond(computedSecond);
                setMinute(computedMinute);

                setCounter((counter) => counter + 1);
            }, 1000);
        }

        return () => clearInterval(intervalId);
    }, [props.start,counter]);


    return (
        <div className={classes.container}>
            <div className={classes.time}>
                <span>{minute}</span>
                <span>:</span>
                <span>{second}</span>
            </div>
        </div>
    );
};

export default Timer;
